import { render, staticRenderFns } from "./StowageDetailCard.vue?vue&type=template&id=3e0d92ac&"
import script from "./StowageDetailCard.vue?vue&type=script&lang=js&"
export * from "./StowageDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./StowageDetailCard.vue?vue&type=style&index=0&id=3e0d92ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports